interface Props {
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

export function SubmitButton({ disabled, loading, children }: Props) {
  return (
    <button type="submit" disabled={disabled || loading} className="ios-btn ios-btn-primary">
      {loading ? "Отправляю..." : children}
    </button>
  );
}
